// Helpers da loja sem login. Formatação de dinheiro, tempo e nome.
import { supabase } from '@/lib/supabase';

// Sempre exibe "R$ X,YY" (nunca "Gratuito").
export function formatarCentavos(centavos: number): string {
  const reais = Math.floor(centavos / 100);
  const cents = centavos % 100;
  return `R$ ${reais.toLocaleString('pt-BR')},${String(cents).padStart(2, '0')}`;
}

// "12:05" a partir de milissegundos restantes.
export function formatarMmSs(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const min = Math.floor(total / 60);
  const seg = total % 60;
  return `${String(min).padStart(2, '0')}:${String(seg).padStart(2, '0')}`;
}

// "20/12 às 20h" — data/hora curta para exibição.
export function formatarDataHora(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const hora = String(d.getHours()).padStart(2, '0');
  return `${dia}/${mes} às ${hora}h`;
}

// Iniciais de um nome ("Maria da Silva" → "MS").
export function iniciaisNome(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return '?';
  if (partes.length === 1) return partes[0].charAt(0).toUpperCase();
  return (partes[0].charAt(0) + partes[partes.length - 1].charAt(0)).toUpperCase();
}

// Chave do localStorage que guarda a carteira deste evento neste aparelho.
export function chaveCarteiraLocal(eventoId: number | string): string {
  return `carteira:${eventoId}`;
}

// Qual carteira guardada neste celular pode ser usada agora? (217 · 05/10/2026)
// Logado: a carteira de OUTRA conta não é usada (a compra vai para a carteira da conta logada).
// Sem login: como sempre (a guardada). Carteira que não existe mais: esquece. Sem resposta do banco: como hoje.
export async function carteiraParaUsar(eventoId: number | string): Promise<string | null> {
  let salva: string | null = null;
  try {
    salva = localStorage.getItem(chaveCarteiraLocal(eventoId));
  } catch {
    return null;
  }
  if (!salva) return null;
  try {
    const { data, error } = await supabase.rpc('loja_carteira_dona', { p_carteira: salva });
    if (error) return salva;
    if (data === 'nao_existe') {
      try { localStorage.removeItem(chaveCarteiraLocal(eventoId)); } catch { /* ignora */ }
      return null;
    }
    if (data === 'outra_conta') return null;
    return salva;
  } catch {
    return salva;
  }
}